<template>
  <aside class="top-bar">
    <div class="nav-wrapper d-flex w-100">
      <span class="nav-logo">
        <img
          id="main-logo"
          class="d-inline-block align-top mr-1"
          style="max-width: 100px;"
          src="@/assets/images/logo.png"
          alt="PetFish - logo" />
      </span>

      <span class="text-dark top-bar-current-user">
        Logged as:
        <router-link to="/dashboard/my-profile/" class="text-primary">
          {{ $store.getters.getUserName }}
        </router-link>
      </span>

      <d-nav class="ml-auto">
        <li
          v-for="(item, navItemIdx) in filteredItems"
          :key="navItemIdx"
          class="nav-item"
          :data-unread-count="item.title === 'Notifications' ? notificationsCount : null">
          <router-link
            :to="item.to"
            :title="item.title">
            <span class="item-icon-wrapper" v-if="item.htmlBefore" v-pure-html="item.htmlBefore" />
            <span class="nav-item-tooltip">
              {{ item.title }}
            </span>
          </router-link>
        </li>
      </d-nav>
    </div>
  </aside>
</template>

<script>
import FormUtils from './../../utils/FormUtils';
import Vue from 'vue';

export default {
  name: 'top-bar',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredItems () {
      let userRole = this.$store.getters.getUserType;
      return this.items.filter(item => !item.permissions || item.permissions.indexOf(userRole) > -1);
    }
  },
  data () {
    return {
      cyclicNotificationsCheck: null,
      notificationsCount: 0
    };
  },
  mounted () {
    this.getNotifications();
    this.$bus.$on('topbar-get-notifications', this.getNotifications);
  },
  methods: {
    getNotifications () {
      if (this.cyclicNotificationsCheck) {
        clearTimeout(this.cyclicNotificationsCheck);
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/notifications/count',
        errorTitle: false,
        errorText: false,
        successAction: (response) => {
          if (response.data && typeof response.data.count !== 'undefined') {
            if (parseInt(response.data.count, 10) > 99) {
              Vue.set(this, 'notificationsCount', '99+');
            } else {
              Vue.set(this, 'notificationsCount', parseInt(response.data.count, 10));
            }
          }
        }
      });

      this.cyclicNotificationsCheck = setTimeout(() => {
        this.getNotifications();
      }, 1 * 60 * 1000);
    }
  },
  beforeDestroy () {
    clearTimeout(this.cyclicNotificationsCheck);
    this.$bus.$off('topbar-get-notifications', this.getNotifications);
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;

  .nav-logo {
    align-items: center;
    display: flex;
    font-size: 24px;
    font-weight: bold;
    justify-content: center;
    height: 48px;
    width: 200px;
  }

  &-current-user {
    line-height: 45px;
  }

  .nav-item {
    align-items: center;
    border-left: 1px solid #eee;
    cursor: pointer;
    display: flex;
    font-size: 24px;
    height: 48px;
    justify-content: center;
    position: relative;
    width: 48px;

    &-tooltip {
      display: none;
    }

    &:hover {
      .nav-item-tooltip {
        background: var(--secondary);
        border-radius: 3px;
        bottom: -28px;
        color: var(--light);
        display: block;
        font-size: 12px;
        left: 50%;
        padding: 3px 8px;
        position: absolute;
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }

    &[data-unread-count] {
      position: relative;

      &:before {
        background: red;
        border-radius: 5px;
        color: #fff;
        content: attr(data-unread-count);
        font-size: 10px;
        font-weight: bold;
        padding: 1px 3px;
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 1;
      }
    }

    &[data-unread-count="0"]:before {
      display: none;
    }
  }
}
</style>
